import { ROUTES } from "Features/Routes/routeConstants";
import { getConfig } from "Config/config";

const getBlogUrl = () => {
  if (getConfig().BlogURL) return getConfig().BlogURL;

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("staging")
  ) {
    return "https://staging.onegrad.ai/blog";
  }

  return "https://www.onegrad.ai/blog";
};

export const PageLinks = [
  {
    key: "1",
    label: "Home",
    target: ROUTES.HOME,
  },
  {
    key: "2",
    label: "Our Team",
    target: ROUTES.OUR_TEAM,
  },
  {
    key: "3",
    label: "How it Works",
    target: ROUTES.DEMOS,
  },
  {
    key: "4",
    label: "Finance",
    target: ROUTES.PUBLIC_FINANCE,
  },
  {
    key: "5",
    label: "Community",
    target: ROUTES.COMMUNITY,
  },
  {
    key: "6",
    label: "Scholarships",
    target: ROUTES.PUBLIC_SCHOLARSHIP,
  },
  {
    key: "7",
    label: "Pricing",
    target: ROUTES.PRICING,
  },
  {
    key: "8",
    label: "Blog",
    target: getBlogUrl(),
    external: true,
  },
];

export const usePageLinks = () => {
  return PageLinks;
};
